// import external dependencies
// import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
// import Router from './util/Router';
// import common from './routes/common';
// import home from './routes/home';
// import aboutUs from './routes/about';

// /** Populate Router instance with DOM routes */
// const routes = new Router({
//   // All pages
//   common,
//   // Home page
//   home,
//   // About Us page, note the change from about-us to aboutUs.
//   aboutUs,
// });

// // Load Events
// jQuery(document).ready(() => routes.loadEvents());
jQuery(document).ready(function() {

  let winwidth = window.innerWidth;

  window.addEventListener('resize', function () {
    winwidth = window.innerWidth;
  })

 
     /** Dropdown on hover */
    $('.nav-link.dropdown-toggle').hover( function () {
      if (winwidth >= 992) {
           // Open up the dropdown
        $(this).removeAttr('data-toggle'); // remove the data-toggle attribute so we can click and follow link
        $(this).parent().addClass('show'); // add the class show to the li parent
        $(this).next().addClass('show'); // add the class show to the dropdown div sibling
      }
    }, function () {
      if (winwidth >= 992) {
        // on mouseout check to see if hovering over the dropdown or the link still
        var isDropdownHovered = $(this).next().filter(':hover').length; // check the dropdown for hover - returns true of false
        var isThisHovered = $(this).filter(':hover').length;  // check the top level item for hover
        if(isDropdownHovered || isThisHovered) {
            // still hovering over the link or the dropdown
        } else {
            // no longer hovering over either - lets remove the 'show' classes
            $(this).attr('data-toggle', 'dropdown'); // put back the data-toggle attr
            $(this).parent().removeClass('show');
            $(this).next().removeClass('show');
        }
      }
    });
    
    // Check the dropdown on hover
    $('.dropdown-menu').hover( function () {
    }, function() {
      if (winwidth >= 992) {
        var isDropdownHovered = $(this).prev().filter(':hover').length; // check the dropdown for hover - returns true of false
        var isThisHovered= $(this).filter(':hover').length;  // check the top level item for hover
        if(isDropdownHovered || isThisHovered) {
            // do nothing - hovering over the dropdown of the top level link
        } else {
            // get rid of the classes showing it
            $(this).parent().removeClass('show');
            $(this).removeClass('show');
        }
      }
    });


  $('.dropdown a.dropdown-toggle').on('click', function() {

    let istopdrop = $(this).parent().hasClass('toplink');

    if (istopdrop == true) {
      $('.dropdown-menu').each(function( index ) {
        $(this).removeClass('show');
      });
    }

  var $subMenu = $(this).next('.dropdown-menu');
  $subMenu.toggleClass('show');

  $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function() {
    $('.dropdown-submenu .show').removeClass('show');
  });

  return false;
});

$('.single-item').slick({
    // normal options...
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    speed: 700,
    fade: true,
});

$('.embraceiteminner').slick({
    // normal options...
    infinite: true,
    // autoplay: true,
    // autoplaySpeed: 8000,
    speed: 700,
    fade: true,
});

$('.gallaunch').click(function (e) { 
  e.preventDefault();
  $('#galclick_0').click();
});

$('.scrolldown').click(function (e) { 
  e.preventDefault();
  $('html, body').animate({
         scrollTop: $('#bottomscript').offset().top,
     }, 1000);
});

$('.photoslider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 1050,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$('.logolist').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 6,
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 1050,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$('.single-item').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  $('.badge').each(function (index, element) {
    $(this).hide();
  });
  $('#badge_'+nextSlide).fadeIn();
});

$('.headslideshow').mouseenter(function () { 
  $('.headslideshow .slick-arrow').fadeTo( 'fast', 1 );
});

$('.headslideshow').mouseleave(function () { 
  $('.headslideshow .slick-arrow').fadeTo( 'fast', 0 );
});

$('.accordian .phead a').each(function(e) {
      $(this).bind('click', function() {
        let indx = e + 1;
        let curhead = $('.phead:eq(' + e + ')');
        let nexthead = $('.phead:eq(' + indx + ')');
        $(curhead).nextUntil(nexthead, '.pbody').toggle()
        return false;
      })
  });

  $('.enews').click(function (e) { 
    e.preventDefault();
    $.fancybox.open({
      src  : '.enewssignup',
      type : 'inline',
      opts : {
        afterShow : function( instance, current ) {
          console.info( 'done!' );
        },
      },
    });
  });

  if($('#campaignhomepop').length >= 1) {
    $.fancybox.open({
      src  : '.campaignpopupouter',
      type : 'inline',
      opts : {
        afterShow : function( instance, current ) {
          console.info( 'done!' );
        },
      },
    });
  }


  $('.loadmoreclick').click(function (e) { 
    e.preventDefault();

    let current_page =  $('#mainwrap').data('page');
    let catid = $(this).attr('cat');
    let tagslug = $(this).attr('tag');

    const data = {
      'action': 'load_more_posts',
      'cat': catid,
      'tag': tagslug,
      'current_page': current_page,
    };
    
    $.ajax({
      type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        data: data,
        dataType: 'dataType',
      }).success(function(data) {
        console.log('done');
      }).fail(function(data) {
        var obj = JSON.parse(data.responseText);

        if (obj.data.length > 0) {
          $( '.postlist ul' ).append( obj.data[0] );
          current_page++;
          $('#mainwrap').data('page', current_page);
          window.history.pushState('', '', '?pg='+current_page);
          if (obj.data[1].next == null) {
            $('.loadmore').html('<h5>That‘s the end...</h5>');
          }
        }
        
      });
    
  });

  }); // close jq


// WEBPACK FOOTER //
// ./scripts/main.js